import { Button } from '@mui/material';
import { PoiBulkUploadActionTypes, useBulkUploadPoiActions } from '../actions';
import { GenericConfirmationDialog } from '@/components/Analysis/shared/GeneriConfirmationDialog';
import { useBulkUploadPoisMutation } from '@/__generated__/graphql';
import { useSnackBarMessage } from '@/utils/useSnackBarMessage';
import * as analysisState from '@/components/Analysis/state';
import { useSetAtom } from 'jotai';
import { xlsxBase64ToJson } from '@/components/Analysis/Idms/utils';
import { useEffect, useState } from 'react';
import { useSelectedAssemblyTemplateId } from '@/components/Analysis/hooks';

export const ConfirmationDialog = () => {
  const setApplyFilters = useSetAtom(analysisState.applyFilters);
  const { state, dispatch } = useBulkUploadPoiActions();
  const [rowCount, setRowCount] = useState(0);

  const [bulkUploadPois, { loading }] = useBulkUploadPoisMutation();

  const { showSnackBar } = useSnackBarMessage({});

  const isOpen = state.modal === 'confirm';
  const selectedAssemblyTemplateId = useSelectedAssemblyTemplateId() ?? '';

  useEffect(() => {
    (async () => {
      if (state?.input?.csv) {
        const { rows } = await xlsxBase64ToJson(state?.input?.csv);
        setRowCount(rows?.length || 0);
      }
    })();
  }, [state?.input?.csv]);

  if (!isOpen) return <></>;

  const { input } = state;

  const onClose = () => {
    dispatch({ type: PoiBulkUploadActionTypes.CLOSE_ALL_MODALS });
  };

  const onConfirm = () => {
    if (!input) {
      showSnackBar('Could not create upload input. Please contact support', 'error');
      return;
    }

    bulkUploadPois({
      variables: {
        input: {
          ...input,
          assemblyTemplateId: selectedAssemblyTemplateId,
        },
      },
    })
      .then(() => {
        // Janky way to get the POI table to re-render
        // and refetch the POIs, to refresh the POI table after an upload is complete
        setApplyFilters(true);
        showSnackBar('Uploaded successfully', 'success');
        showSnackBar('Points of interest uploaded successfully', 'success');
        onClose();
      })
      .catch(() => {
        showSnackBar('Could not upload points of interest. Please contact support', 'error');
      });
  };

  return (
    <GenericConfirmationDialog
      title="Adding points of interest"
      description={`File validation completed. Please confirm to update the data by adding '${rowCount}' points of interest to Abyss fabric.`}
      open={isOpen}
      onClose={onClose}
    >
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onConfirm} disabled={loading} variant="contained">
        Confirm
      </Button>
    </GenericConfirmationDialog>
  );
};
